import { styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as HelixFooterLogo } from '@assets/helix-footer-logo.svg';

export const StyledFooterContainer = styled('footer', {
  background: '$white',
  borderTop: '$borderWidths$1 solid $seafoam',
  boxShadow: '$footer',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '$10 $8 0 $8',
});

export const StyledRow = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  lineHeight: '$4',
  maxWidth: '$studyInsights$headerMaxWidth',
  width: '100%',
});

export const StyledLink = styled('a', {
  borderRight: '$borderWidths$1 solid $darkBlue700',
  color: '$darkBlue300',
  cursor: 'pointer',
  fontSize: '$md',
  fontWeight: '$bold',
  height: '$6',
  padding: '0 $6',
  textAlign: 'start',
  textDecoration: 'none',
  whiteSpace: 'pre',

  '&:last-child': {
    borderRight: 'none',
    paddingRight: '0',
  },

  variants: {
    size: {
      sm: { fontSize: '$xs', paddingLeft: '0' },
    },
  },
});

export const StyledCopyright = styled(Box, {
  color: '#494949',
  display: 'flex',
  fontSize: '$xs',
});

export const StyledAllRight = styled(Box, {
  color: '#919191',
  display: 'flex',
  fontSize: '$xs',
  maxWidth: '400px',
  textAlign: 'start',
});

export const StyledContact = styled(Box, {
  color: '$black',
  fontSize: '$md',
});

export const StyledClinicalLaboratory = styled(Box, {
  color: '#616161',
  display: 'flex',
  fontSize: '$md',
  justifyContent: 'space-between',
  marginLeft: '$3',
});

export const StyledContactContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',
  lineHeight: '$4',
});

export const StyledFooterLogo = styled(HelixFooterLogo, {
  height: '$10',
  width: 'auto',
});

export const StyledColumn = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
});
